import { useState } from "react";
import { FileSpreadsheet } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/Button";
import { downloadExcel } from "@/lib/excelExport";

// Mismo botón en cualquier listado con estadísticas — nunca una tabla en pantalla que no se pueda
// sacar a Excel.
export function ExportExcelButton({ url, filename }: { url: string; filename: string }) {
  const [loading, setLoading] = useState(false);

  async function handleClick() {
    setLoading(true);
    try {
      await downloadExcel(url, filename);
    } catch {
      toast.error("No se pudo exportar a Excel");
    } finally {
      setLoading(false);
    }
  }

  return (
    <Button onClick={handleClick} disabled={loading}>
      <FileSpreadsheet className="h-4 w-4" />
      {loading ? "Exportando…" : "Exportar a Excel"}
    </Button>
  );
}
